import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { setGlobalLoading } from 'redux/actions/actionCommon'
import { addPaymentIntegration, getPaymnetIntegartion } from 'utlis/Apis/Payment_API'
import { ERROR_WHILE_FETCHING_PAYMENTINTEGRATION } from 'utlis/AppMessages/AppMessages'
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages'
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages'
import "./styles/payment-styles.scss"
import PaymentView from './includes/PaymentView'
import { ERROR_WHILE_CREATING_CUSTOMERGROUP } from 'utlis/AppMessages/AppMessages'

function ProductFilters(props) {
    const [payment, setPaymentIntegrations] = useState({})
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setLoading(true)
        getPaymnetIntegartion(props.currentUser.userToken, props.currentUser.userId).then(res => {
            setLoading(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setPaymentIntegrations(ps => JSON.parse(resData.data || "{}") || {})
                console.log(JSON.parse(resData.data || "{}") || {}, resData.data)
            }

            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_PAYMENTINTEGRATION, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                }
            })
        })

    }, [props.currentUser.token, props])

    const addPaymentIntegration_ = (payment_) => {
        setPaymentIntegrations(ps => ({ ...payment_ }))
        const data = {
            account_id: props.currentUser.userId,
            data: JSON.stringify(payment_)
        }
        addPaymentIntegration(props.currentUser.userToken, data).then(res => {
            setGlobalLoading(false)
            const addingPaymentIntegration = res.data
            if (addingPaymentIntegration.success) {
                window.scrollTo(0, 0)
            }
            if (addingPaymentIntegration.error) {
                console.log(ERROR_WHILE_CREATING_CUSTOMERGROUP, res)
                toast.dismiss();
                toast.error(addingPaymentIntegration.message || ERROR_WHILE_CREATING_CUSTOMERGROUP, {
                    autoClose: 3000,
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} addingPaymentIntegration `, err.message)
            toast.dismiss();
            toast.error(err.message || UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => { }
            })
        })
    }

    return (
        <section id="app-payment" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                <div className="app-product-filters">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Payment</p>
                    </div>
                    <PaymentView
                        payment={payment}
                        addPaymentIntegration_={addPaymentIntegration_}
                        loading={loading}
                    />
                </div>
            </Container>
        </section>
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(ProductFilters)